
declare const AddressIDSymbol: unique symbol
export type AddressID = string & { [AddressIDSymbol]: never }

export interface AddressDto {
    id: string
    address_line_1: string
    address_line_2: string | null
    city: string
    post_code: string
    state: string | null
    country: string
}

export interface Address {
    id: AddressID
    addressLine1: string
    addressLine2: string | null
    city: string
    postCode: string
    state: string | null
    country: string
}

export const createAddress = (
    params: {
        id: AddressID,
        addressLine1: string,
        addressLine2: string | null,
        city: string,
        postCode: string,
        state: string | null,
        country: string
    }
): Address => ({
    id: params.id,
    addressLine1: params.addressLine1,
    addressLine2: params.addressLine2,
    city: params.city,
    postCode: params.postCode,
    state: params.state,
    country: params.country,
})

export const addressFromDto = (dto: AddressDto): Address => (createAddress({
    id: dto.id as AddressID,
    addressLine1: dto.address_line_1,
    addressLine2: dto.address_line_2,
    city: dto.city,
    postCode: dto.post_code,
    state: dto.state,
    country: dto.country,
}))
